import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/content/variables/$typeId/")({
  beforeLoad: ({ params }) => {
    // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
    throw redirect({
      to: "/content/variables/$typeId/values",
      params,
    });
  },
});
